var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.5 5C10.5 3.9 11.4 3 12.5 3C13.5214 3 14.3704 3.77602 14.4865 4.7676L14.5 5V9.18L15.08 8.58C15.44 8.22 15.94 8 16.5 8C17.6 8 18.5 8.9 18.5 10C18.5 10.4667 18.3472 10.8917 18.088 11.2287L17.92 11.42L13.92 15.42C13.56 15.78 13.06 16 12.5 16C12.0333 16 11.6083 15.8472 11.2713 15.588L11.08 15.42L7.08 11.42C6.72 11.06 6.5 10.56 6.5 10C6.5 8.9 7.4 8 8.5 8C8.98 8 9.41592 8.16163 9.75738 8.44711L9.92 8.6L10.5 9.18V5ZM6.5 18C5.94772 18 5.5 18.4477 5.5 19V20C5.5 20.5523 5.94772 21 6.5 21H18.5C19.0523 21 19.5 20.5523 19.5 20V19C19.5 18.4477 19.0523 18 18.5 18H6.5Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.86476ec3.svg";
export { ForwardRef as ReactComponent };